import axios from 'axios';
import React from 'react';
import { withSnackbar } from 'notistack';
import {Auth, Firestore as db} from "../firebase"
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';
import { collection, getDocs } from "firebase/firestore";
import { BINANCE_SOCKET } from '../utlis/BinanceWebSocket';

const StoreContext = React.createContext();

// Then create a provider Component
class StoreProvider extends React.Component {
  constructor(props){
    super(props);
    // Application Global State
    this.state = {
        // State Examples
        mongoAPIKey : "CmOWNLVnEcm5Skuck51IUtC78iRCYqKPhe3Hox9qhN3Mfm7hHVHbBhaFr3rO1RGh",
        isLoggedIn : localStorage.getItem('token') ? true : false,
        user : [],
        data : "I am Loaded From Global State",
        errors : {},
        firestore : {},
        marketData : {},
        pairsToTrack : [],
        loading : false
    }
}

  render() {
    return (
      <StoreContext.Provider value = {{ 
        state: this.state,

        // Actions
        fetchFirestore : async () => {
          console.log("sdas")
          let firebase = {};
          try {
            const querySnapshot = await getDocs(collection(db, "instances"));
            querySnapshot.forEach(async (doc) => {
              // doc.data() is never undefined for query doc snapshots
              console.log(doc.id, " => ", doc.data());
              firebase[doc.id] = doc.data();
              try {
                firebase[doc.id].orders = {}
                const ordersSnapshot = await getDocs(collection(db, `instances/${doc.id}/orders`));
                ordersSnapshot.forEach(async (doc_) => {
                  // doc.data() is never undefined for query doc snapshots
                  console.log(doc_.id, " => ", doc_.data());
                  firebase[doc.id].orders[doc_.id] = doc_.data();
                });
              }
              catch(error) {
                console.error(error)
              }
            });

            this.setState({
              firestore : {
                ...firebase,
                ...this.state.firestore
              }
            })
          }
          catch(error) {
            console.error(error)
          }
        },

        fetchDataByPair : async (pairs) => {

         await BINANCE_SOCKET.send(JSON.stringify({
            "method": "SUBSCRIBE",
            "params": pairs,
            "id": 2
          }))
        },

        fetchMarketData : async (pairs)=> {
          

          BINANCE_SOCKET.addEventListener('open', (event) => {
              this.setState({loading: true})
              console.log("Open Socket")
            });
            
            BINANCE_SOCKET.send(JSON.stringify(
              {
                "method": "SUBSCRIBE",
                "params": pairs,
                "id": 2
              }
            ))

            BINANCE_SOCKET.onmessage = (evt) => {
              const res = JSON.parse(evt.data)
              if(res.result === null && res.id) {
                console.log("Connected!")
                //this.props.enqueueSnackbar("Connected To The Web Socket")
                this.setState({loading: false})
              }
              else {
                let timestamp = new Date().getTime()

                if(timestamp % 10 === 0) {
                  this.setState({
                    marketData : {
                      ...this.state.marketData,
                      [res.s] : res.p
                    }
                  })
                }
              }
            //  switch(res) {
            //    case
            //  }
            //console.log(res)
            }

            // socket.addEventListener('close', function (event) { 
            //   console.log('The connection has been closed'); 
            // });
          },

        fetchData : async (isfirstTime= true) => {
          this.setState({loading: true})
          var data = JSON.stringify({"dataSource":"Cluster0","database":"vaayu","collection":"instances",
        });

          var config = {
            method: 'post',
            url: 'https://corsanywhereintwiff.herokuapp.com/https://data.mongodb-api.com/app/data-deabb/endpoint/data/beta/action/find',
            headers: { 
              'api-key': 'CmOWNLVnEcm5Skuck51IUtC78iRCYqKPhe3Hox9qhN3Mfm7hHVHbBhaFr3rO1RGh', 
              'Content-Type': 'application/json'
            },
            data : data
          };

          axios(config)
          .then((response) => {
            let data = {};
            response.data.documents.map((doc) => {

              data[doc.firestore_id] = doc;

              if( !(doc.firestore_id in this.state.firestore) && !isfirstTime) {
                data[doc.firestore_id].isNew = true
              }
              
              data[doc.firestore_id].overall_stats = {
                total_gain : 0,
                total_loss : 0,
                winning_trades : 0,
                losing_trades : 0,
              };

              Object.keys(doc?.analytics?.coins).map((key) => {
                data[doc.firestore_id].overall_stats.winning_trades += data[doc.firestore_id].analytics.coins[key].winning_trades;
                data[doc.firestore_id].overall_stats.losing_trades += data[doc.firestore_id].analytics.coins[key].losing_trades;
                data[doc.firestore_id].overall_stats.total_gain += data[doc.firestore_id].analytics.coins[key].total_gain;
                data[doc.firestore_id].overall_stats.total_loss += data[doc.firestore_id].analytics.coins[key].total_loss;
              })
            })

            this.setState({
              firestore : data,
              loading : false
            })

            
          })
          .catch((error)=> {
            console.log(error);
            this.setState({loading: false})
          });
        },

        loginWithFirebase : async (e) => {
          const { email, password } = e.target.elements;
          try {
            console.log(email.value, password.value)
            signInWithEmailAndPassword(Auth, email, password)
            .then((userCredential) => {
              // Signed in 
              const user = userCredential.user;
              console.log(user)
              // ...
            })
            .catch((error) => {
              const errorCode = error.code;
              const errorMessage = error.message;
            });
            // localStorage.setItem('token', res.user.uid);
            // this.setState({
            //   isLoggedIn : true,
            //   user : res.user
            // })
          } catch (err) {
            this.setState({
              errors : err.message
            })
          }
        },
        signupWithFirebase : async (username, password) => {
         // e.preventDefault()
         // const { email, password } = e.target.elements;
          try {
            
        //    console.log(email.value, password.value)
            createUserWithEmailAndPassword(Auth, username, password)
            .then((userCredential) => {
              // Signed in 
              const user = userCredential.user;
              this.setState({
                user : [...this.state.user, user]
              })
              console.log(user)
              // ...
            })
            .catch((error) => {
              const errorCode = error.code;
              console.log(errorCode)
              if(errorCode === "auth/email-already-in-use") {
                signInWithEmailAndPassword(Auth, username, password)
                .then((userCredential) => {
                  // Signed in 
                  const user = userCredential.user;
                  this.setState({
                    user : [...this.state.user, user]
                  })
                  console.log(user)
                  // ...
                })
                .catch((error) => {
                  const errorMessage = error.message;
                    this.props.enqueueSnackbar(errorMessage, { 
                      variant: 'error',
                  })
                });
              }

              // ..
            });
            // localStorage.setItem('token', res.user.uid);
            // this.setState({
            //   isLoggedIn : true,
            //   user : res.user
            // })
          } catch (err) {
            console.log(err)
            this.setState({
              errors : err.message
            })
          }
        },

        login : async(e)=>  {
          this.setState({
            loading : true
          })
          axios.post(`auth/token/login/`, new FormData(e)).then(async (res)=> {
            console.log(res.data)
            localStorage.setItem('token', res.data.auth_token)
            await axios.get(`auth/users/me/`, {
              headers : {
                authorization : `Token ${res.data.auth_token}`
              }
            }).then(async (res)=> {
              this.setState({
                user : res.data,
                loading : false
              })
            })
            this.props.enqueueSnackbar("Data Saved", { 
              variant: 'default',
          })
          window.location.href = "/"
            })
          .catch((err) => {
            this.setState({
              loading : false
            })
            let error = ''
            if(err.response.data.non_field_errors) {
              error = err.response.data.non_field_errors.join(', ')
            }
            else {
              error = err.message
            }
            this.props.enqueueSnackbar("Data Saved", { 
              variant: 'error',
          })
          })
        },

        submitForm : async (key, data)=> {
          let temp = []
          if(this.state.data[`${key}`]) {
            temp = this.state.data[`${key}`]
          }

          axios.post(`${key}/`, new FormData(data)).then(async (res)=> {

            await axios.get(`${key}/`).then(async (res)=> {
              this.setState({
                [`${key}`] : res.data
              })
            })
          //   this.props.enqueueSnackbar("Data Saved", { 
          //     variant: 'default',
          // })
            })
          .catch((err) => {
          //   this.props.enqueueSnackbar(err, { 
          //     variant: 'warning',
          // })
          })

        },

        editForm : async (key, id, e)=> {
          let temp = []
          if(this.state.data[`${key}`]) {
            temp = this.state.data[`${key}`]
          }

          axios.patch(`${key}/${id}/`, new FormData(e)).then(async (res)=> {

            await axios.get(`${key}/`).then(async (res)=> {
              this.setState({
                [`${key}`] : res.data
              })
            })
          //   this.props.enqueueSnackbar("Data Saved", { 
          //     variant: 'default',
          // })
            })
          .catch((err) => {
          //   this.props.enqueueSnackbar(err, { 
          //     variant: 'warning',
          // })
          })

        },


        deleteWithKey : async (key, id)=> {
          let temp = []
          if(this.state.data[`${key}`]) {
            temp = this.state.data[`${key}`]
          }

          axios.delete(`${key}/${id}/`).then(async (res)=> {

            await axios.get(`${key}/`).then(async (res)=> {
              this.setState({
                [`${key}`] : res.data
              })
            })
          //   this.props.enqueueSnackbar("Data Saved", { 
          //     variant: 'default',
          // })
            })
          .catch((err) => {
          //   this.props.enqueueSnackbar(err, { 
          //     variant: 'warning',
          // })
          })

        },

        setEditId : (id)=>{
          this.setState({
            currentEditId: id,
          })
        },

        fetchWithKey : async(key)=> {

          await axios.get(`${key}/`).then(async (res)=> {
            this.setState({
              [`${key}`] : res.data
            })
          //   this.props.enqueueSnackbar("Data Saved", { 
          //     variant: 'default',
          // })
            })
          .catch((err) => {
          //   this.props.enqueueSnackbar(err, { 
          //     variant: 'warning',
          // })
          })
        },
        // State Mutations
        changeState :(data)=> {
            // change state
            // this.setState({
            //     token : "",
            //     isLoggedIn : true
            //   })
        }, 
      }} 	
        >
        {this.props.children}
      </StoreContext.Provider>
    )
  }
}

export {StoreContext};

export default withSnackbar(StoreProvider);